//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Morisky',
  data () {
    return {
      form: {
        occ: '0',
        no_med: '0',
        stop_med: '0',
        take_med: '0',
        eat_med: '0',
        better: '0',
        persist: '0',
        schedule: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '1', name: '从不'},
        {value: '0.75', name: '偶尔'},
        {value: '0.5', name: '有时'},
        {value: '0.25', name: '经常'},
        {value: '0', name: '所有时间'}
      ],
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      console.log(self.form)
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }

      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        console.log(form)
        let result = (form.occ == '1' ? 0 : 1)
          + (form.no_med == '1' ? 0 : 1)
          + (form.stop_med == '1' ? 0 : 1)
          + (form.take_med == '1' ? 0 : 1)
          + form.eat_med
          + (form.better == '1' ? 0 : 1)
          + (form.persist == '1' ? 0 : 1) + form.schedule
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Morisky.vue